<!-- 订单确认 -->
<template>
  <div id="getOrderInfo" class="business-content-main">
    <div class="order-info-title">填写并核对订单信息</div>
    <div class="order-info-main">
      <div
        class="step-tit"
        style="line-height: 40px;height: 40px;display: flex;"
      >
        <div class="item-title">收货人信息</div>
        <div class="add-address" @click="showAddress">新增收货地址</div>
      </div>
      <div class="address-ctn" :class="{ 'address-open': addressOpen }">
        <div
          class="address-item"
          v-for="(item, index) in addressList"
          :key="item.Id"
          @click="toggleAddress(item, index)"
        >
          <div
            class="add-item"
            :class="{ 'target-checked': addressIndex == index }"
            style="width: 144px"
          >
            <span>{{ item.Tags }}</span>
            <span class="gou"></span>
          </div>
          <div class="add-dir">{{ item.Contactor }}</div>
          <div class="add-dir">
            {{ item.Province }}{{ item.City }}{{ item.District }}{{ item.Addr }}
          </div>
          <div class="add-dir">{{ item.PhoneNum }}</div>
          <div class="add-dir default-address" v-if="item.IsDefault">
            默认地址
          </div>
          <div class="ops-ctn">
            <span @click.stop="setDefault(item)" v-if="!item.IsDefault"
              >设为默认地址</span
            >
            <span @click.stop="addressEdit(item)">编辑</span>
            <span @click.stop="addressDel(item)">删除</span>
          </div>
        </div>
      </div>
      <div class="open-btn" style="margin-bottom: 10px;">
        <span @click="openAddress(1)" v-if="addressOpen">展开</span>
        <span @click="openAddress(0)" v-else>收起</span>
      </div>
      <div class="send-goods-list">
        <div class="step-tit">
          <div class="item-title">
            <span>送货清单</span>
            <el-link
              type="primary"
              @click="gotoBuyCar"
              style="width:auto;float:right"
              >返回购买</el-link
            >
          </div>
          <!--   主体商品  -->
          <div class="goods-item">
            <div class="image-ctn goods-cover">
              <img :src="goods.goodsImg" :onerror="defaultImg" />
            </div>
            <div class="goods-dir" :title="goods.GoodsName">
              {{ goods.GoodsName }}
            </div>
            <div class="goods-num">
              <p>￥{{ goods.SellPrice }}</p>
              <el-input-number
                :underline="false"
                v-model="goodsOrderData.buyQuantity"
                :min="1"
                :max="goods.ShareCount"
                label="商品数量"
              ></el-input-number>
            </div>
          </div>
        </div>
      </div>
      <div class="money-count">
        <div>
          <p>
            <span class="key">
              <el-tooltip class="item" effect="light">
                <div slot="content">
                  订单可能会产生运费 <br />如果产生运费会有客服与您沟通具体细节
                </div>
                <i
                  class="el-icon-question"
                  style="color: orange"
                ></i> </el-tooltip
              >运费:
            </span>
            <span class="value">￥0.00</span>
          </p>
        </div>
      </div>
      <div class="trade-foot-detail-com">
        <div>
          应付总额：
          <span class="price-num">￥{{ finalMoney }}</span>
        </div>
        <div>
          <span>
            寄送至： {{ chooseAddress.Province }}{{ chooseAddress.City
            }}{{ chooseAddress.District }}{{ chooseAddress.Addr }}
          </span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <span>
            收货人：{{ chooseAddress.Contactor }}
            {{ chooseAddress.PhoneNum }}
          </span>
        </div>
      </div>
      <div class="sub-btn-ctn">
        <div class="sub-btn" @click="submitData">提交订单</div>
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="地址"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
      custom-class="base-dialog"
      width="800px"
    >
      <addAddress
        ref="addAddress"
        :submitType="addressType"
        :addrData="this.addressData"
        :areaSelect="this.areaSelect"
        @resetData="clearDialog"
        @loadData="changeAddress"
      ></addAddress>
    </el-dialog>
  </div>
</template>
<script>
import addAddress from "@/components/common/addAddress";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    addAddress
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      GoodsTypeId: "",
      finalMoney: 0, // 最终实付价格
      downloadUrl: this.$util.QN_URL_BASE,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      goodsOrderData: {
        userId: userMsg.EmployeeId,
        addressId: "",
        goodsId: "",
        buyQuantity: 1
      },
      buyQuantity: 1,
      goods: {
        goodsImg: ""
      },
      invoiceVisible: false,
      addressType: 1, //
      dialogVisible: false,
      addressList: [],
      addressIndex: 0,
      addressOpen: true,
      addressData: {},
      areaSelect: [], // 地址三级联动
      chooseAddress: {} // 选中的地址
    };
  },
  watch: {
    "goodsOrderData.buyQuantity": {
      handler: function(value) {
        this.finalMoney = value * this.goods.SellPrice;
        this.finalMoney.toFixed(2);
      }
    }
  },
  mounted() {
    this.getAddressList();
    this.goodsOrderData.goodsId = this.$route.query.goodsId;
    this.goodsOrderData.buyQuantity = this.$route.query.buyQuantity
      ? this.$route.query.buyQuantity
      : 1;
    this.getGoodsDetail(this.goodsOrderData.goodsId);
  },
  methods: {
    handleClose() {
      this.$refs.addAddress.resetForm();
      this.dialogVisible = false;
    },
    clearDialog() {
      this.$refs.addAddress.resetForm();
      this.dialogVisible = false;
    },
    // 获取商品详情
    getGoodsDetail(_goodsId) {
      this.$util
        .axiosGet({
          url: "/api/ShareInventory/GetSearchSharedGoods",
          data: {
            goodsId: _goodsId,
          }
        })
        .then(res => {
          if (res.data) {
            this.goods = res.data;
            this.goods.goodsImg = this.downloadUrl + this.goods.MainImg;
            this.finalMoney =
              this.goods.SellPrice * this.goodsOrderData.buyQuantity;
          }
        })
        .catch(err => {});
    },
    // 提交
    submitData() {
      if (!this.chooseAddress.Id) {
        this.$util.warningMsg("请选择地址");
        return;
      }
      this.goodsOrderData.addressId = this.chooseAddress.Id;
      this.$util
        .axiosPost({
          url: "/api/ShareInventory/SubmitSGoodsOrder",
          data: this.goodsOrderData
        })
        .then(res => {
          if (res.data) {
            this.$router.push(`/shareInventory/pay?osn=${res.data}`);
          }
        })
        .catch(err => {});
    },
    // 地址添加成功后要进行的操作
    changeAddress(type, data) {
      this.getAddressList();
      this.clearDialog();
    },
    // 关闭发票
    closeInvoice() {
      this.invoiceVisible = false;
    },
    // 显示发票
    editInvoice() {
      this.invoiceVisible = true;
    },
    // 设为默认地址
    setDefault(data) {
      this.$util
        .axiosPost({
          url: "/api/PurchaseManager/SetASDefaultAddress",
          data: {
            addrId: data.Id,
            entpId: this.userMsg.EntpId,
            operator: this.userMsg.EmployeeId
          }
        })
        .then(() => {
          this.getAddressList();
        })
        .catch(err => {});
    },
    // 编辑
    addressEdit(data) {
      this.addressType = 2;
      this.addressData = data;
      this.areaSelect = [data.Province, data.City, data.District];
      this.dialogVisible = true;
    },
    // 删除
    addressDel(data) {
      let that = this;
      this.$util.elConfirm({
        content: "确定要删除该地址吗？",
        confirm() {
          that.$util
            .axiosGet({
              url: "/api/EntpInfoManagement/DeleteAddress",
              data: {
                AddrId: data.Id,
                Uid: that.userMsg.EmployeeId
              }
            })
            .then(() => {
              that.getAddressList();
            })
            .catch(err => {});
        }
      });
    },

    // 展开收起地址
    openAddress(flag) {
      if (flag) {
        this.addressOpen = false;
      } else {
        this.addressOpen = true;
      }
    },
    // 切换地址
    toggleAddress(item, index) {
      this.addressList.splice(index, 1);
      this.addressList.unshift(item);
      this.addressOpen = true;
      this.chooseAddress = item;
    },
    // 获取地址列表
    getAddressList() {
      this.$util
        .axiosGet({
          url: "/api/EntpInfoManagement/GetAddressList",
          data: {
            EntpId: this.userMsg.EntpId
          }
        })
        .then(res => {
          if (res.data) {
            let data = res.data;
            this.addressList = data;
            this.chooseAddress = data[0];
          }
        })
        .catch(err => {});
    },
    // 跳转购物车
    gotoBuyCar() {
      window.history.back(-1);
    },
    // 显示新增地址弹窗
    showAddress() {
      this.dialogVisible = true;
    }
  }
};
</script>
<style lang="less" scoped>
.hg-goods {
  display: flex;
  align-items: center;
}
.show-hg-btn {
  cursor: pointer;
}
.order-msg {
  display: flex;
  padding: 20px;
  justify-content: space-between;
  align-items: center;
}
.gift-type {
  padding-left: 70px;
}
.goods-type-icon {
  border: 1px solid red;
  background: #ffdedf;
  color: red;
  padding: 0 5px;
  border-radius: 5px;
  margin-right: 5px;
}
.gift-cover {
  width: 70px;
  height: 70px;
  margin-right: 20px;
  margin-left: 10px;
  img {
    max-width: 70px;
    max-height: 70px;
  }
}
.activity {
  display: flex;
  padding: 5px 0;
}
.promotion-item {
  display: flex;
  margin-right: 20px;
}
.promotion-dir {
  height: 20px;
  line-height: 20px;
  margin-right: 5px;
}
.promotion-type {
  background: red;
  color: white;
  width: 50px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  margin-right: 5px;
}
.coupon-open {
  height: auto !important;
}
.goods-cover {
  width: 100px;
  height: 100px;
  img {
    max-width: 100px;
    max-height: 100px;
  }
}
.toggle-item {
  display: none;
}
.business-content-main {
  margin: 0 auto;
  max-width: 1200px;
}
.pay-way-item {
  min-width: 140px;
  width: auto !important;
  margin-bottom: 10px;
}
.address-item {
  position: relative;
  &:hover {
    background: @border3Color;
    .ops-ctn {
      display: block;
    }
  }
  .ops-ctn {
    display: none;
    position: absolute;
    line-height: 26px;
    top: 0;
    right: 0;
    span {
      cursor: pointer;
      color: #005ea7;
      margin-left: 10px;
    }
  }
}
.address-open {
  height: 46px;
}
.address-ctn {
  overflow: hidden;
}
.sub-btn-ctn {
  text-align: right;
  padding-bottom: 30px;
}
.sub-btn {
  text-align: center;
  position: relative;
  width: 135px;
  height: 36px;
  line-height: 36px;
  margin: 8px 0 0;
  background-color: @theme;
  color: #fff;
  font-weight: 700;
  font-size: 16px;
  font-family: arial, "Microsoft YaHei";
  display: inline-block;
  border-radius: 3px;
  cursor: pointer;
}
.price-num {
  color: #e4393c;
  font-family: Verdana;
  font-weight: 700;
  font-size: 18px;
  min-width: 122px;
  width: 122px;
}
.trade-foot-detail-com {
  background: @border3Color;
  padding: 10px;
  text-align: right;
  > div {
    margin-bottom: 20px;
  }
}
.money-count {
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
  span {
    display: inline-block;
  }
  p {
    padding-bottom: 20px;
  }
  .key {
    width: 200px;
    text-align: right;
  }
  .value {
    width: 100px;
    text-align: right;
  }
}
.coupon-money {
  width: 100%;
  background-color: @border3Color;
  display: block;
  clear: both;
  height: 38px;
  margin-top: 15px;
  padding: 10px 20px;
  font-size: 12px;
}
.couponLv2Tab {
  padding: 20px 0;
  display: flex;
  > div {
    cursor: pointer;
    margin-right: 50px;
  }
}
.tabLv2-active {
  border-bottom: 2px solid @theme;
  color: @theme;
}
.coupon-type {
  margin-top: 20px;
  border: 1px solid @border3Color;
}
.coupon-tab {
  display: flex;
  background: @border3Color;
  > div {
    cursor: pointer;
    width: 100px;
    height: 38px;
    line-height: 38px;
    text-align: center;
  }
}
.item-title {
  // width: 100%;
  font-weight: bold;
  padding-bottom: 20px;
}
.coupon {
  padding-top: 20px;
  height: 100px;
  overflow: hidden;
}
.edit-invoice {
  cursor: pointer;
  color: #005ea7;
}
.invoice-type {
  padding-top: 20px;
  padding-left: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid @border3Color;
  > span {
    display: inline-block;
    margin-right: 30px;
  }
}
.triangle {
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-right: 10px solid @border3Color;
  border-bottom: 8px solid transparent;
}
.invoice-title {
  font-weight: bold;
  margin-right: 10px;
}
.invoice-msg {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid @border3Color;
  display: flex;
  align-items: center;
  .tooltip {
    border-radius: 5px;
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    background: @border3Color;
    font-size: 12px;
  }
}
.add-dir {
  padding-right: 30px;
}
.goods-inventory {
  width: 80px;
  text-align: right;
}
.goods-num {
  display: flex;
  text-align: right;
  align-items: center;
  p {
    margin-right: 20px;
    color: red;
    font-size: 16px;
    font-weight: bold;
  }
}
.goods-item {
  background: #f2f6fc;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 150px;
  align-items: center;
  padding-right: 20px;
  padding-left: 20px;
  padding-bottom: 10px;
}
.goods-dir {
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 10px 0 10px 20px;
}
.goods-weight {
  position: absolute;
  left: 20px;
  bottom: 10px;
  font-weight: bold;
}
.business-content-main {
  min-width: 1000px;
}
.mode-tab-nav {
  display: flex;
  margin: 10px 0 20px;
}
.order-info-title {
  height: 42px;
  line-height: 42px;
  font-size: 16px;
  font-family: "Microsoft YaHei";
  overflow: hidden;
}
.order-info-main {
  display: flex;
  flex-direction: column;
  border: 1px solid @border3Color;
  padding: 0 20px;
}
.step-tit {
  color: #333;
  justify-content: space-between;
}
.add-address {
  color: #005ea7;
  cursor: pointer;
}
.default-address {
  color: white;
  background: @font3Color;
  padding: 5px;
}
.pay-way-ctn {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding-bottom: 10px;
}
.send-goods-list-main {
  height: 350px;

  //   display: flex;
  //   position: relative;
}
.send-way {
  width: 300px;
  background: @border3Color;
  padding: 10px 10px 30px 20px;
}
.goods-list {
  flex-grow: 1;
  background: @border4Color;
  padding: 20px;
}
.open-btn {
  cursor: pointer;
  color: @theme;
}
.coupon-title {
  color: @theme;
  padding: 20px 0 10px 0;
  font-size: @font-sm;
}
</style>
